import { render } from "./chatContainer.vue?vue&type=template&id=9582ec9a&ts=true"
import script from "./chatContainer.vue?vue&type=script&lang=ts"
export * from "./chatContainer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__